import { authServices } from "@utils/setupApi";

export const getListLoanTransaction = (parameter) => {
  return authServices({
    method: "GET",
    url: `${process.env.REACT_APP_API}/v3/transaction/loan`,
    parameter,
  });
};
